import React from 'react';
import PropTypes from 'prop-types';

// Assets
import mediumNoImage from './medium_no_image.png';
import largeNoImage from './large_no_image.jpeg';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ListGridCoverPhoto.css'
import cx from 'classnames';
import {
    Col,
    Row
} from 'react-bootstrap';

class ListGridCoverPhoto extends React.Component {
    static propTypes = {
        coverPhoto: PropTypes.number,
        listPhotos: PropTypes.array,
        className: PropTypes.string,
        bgImage: PropTypes.bool,
        openImageLightBox: PropTypes.func.isRequired
    };

    static defaultProps = {
        bgImage: false
    }

    constructor(props) {
        super(props);
        this.state = {
            photo: null
        };
    }

    componentWillMount() {
        const { coverPhoto, listPhotos } = this.props;
        let activePhoto;
        if (listPhotos != undefined && listPhotos.length > 0) {
            activePhoto = listPhotos[0].name;
            if (coverPhoto != undefined && coverPhoto != null) {
                listPhotos.map((item) => {
                    if (item.id === coverPhoto) {
                        activePhoto = item.name;
                    }
                })
            }
            this.setState({ photo: activePhoto });
        }
    }

    componentWillReceiveProps(nextProps) {
        const { coverPhoto, listPhotos } = nextProps;
        let activePhoto;
        if (listPhotos != undefined && listPhotos.length > 0) {
            activePhoto = listPhotos[0].name;
            if (coverPhoto != undefined && coverPhoto != null) {
                listPhotos.map((item) => {
                    if (item.id === coverPhoto) {
                        activePhoto = item.name;
                    }
                })
            }
            this.setState({ photo: activePhoto });
        }
    }

    render() {
        const { className, photoType, bgImage, listPhotos, openImageLightBox, threeSixtyCode } = this.props;
        const { photo } = this.state;


        let index=0;
        let img0, img1, img2, img4, img5;
        if (listPhotos != undefined && listPhotos.length > 0) {
            if( !(threeSixtyCode) ) {
              img0 = listPhotos[index++].src;
            }
            if (listPhotos.length > index) img1 = listPhotos[index++].src;
            if (listPhotos.length > index) img2 = listPhotos[index++].src;
            if (listPhotos.length > index) img4 = listPhotos[index++].src;
            if (listPhotos.length > index) img5 = listPhotos[index++].src;
        }

        let path = '', source;
        if (photo != null) {
            source = photo;
            if (photoType != undefined) {
                path = '/images/upload/' + photoType + '_';
            }
        } else {
            if (photoType != undefined) {
                if (photoType === "xx_large") {
                    source = largeNoImage;
                } else if (photoType === "x_medium") {
                    source = mediumNoImage;
                }
            } else {
                source = mediumNoImage
            }
        }

        if (bgImage) {

            return (
                <div className={'viewListGridPhoto'}>
                    <Col xs={12} md={12} lg={12} className={cx(s.leftBanner, 'rightTopBannerRTL', s.space3)}>
                    {
                      !(threeSixtyCode) ? <div className={cx(className, s.bgbanner, s.borderTopImageRadius)} style={{ backgroundImage: `url(${img0})` }} onClick={() => openImageLightBox(0)}>
                            {this.props.children}
                        </div>
                      :
                      (
                        threeSixtyCode.type == 'matterport' ?
                        <div className={cx(className, s.bgbanner)}><iframe className={cx(s.borderTopImageRadius)} style={{ width: '100%', height: '480px', border: 'none' }} src={`https://my.matterport.com/show/?m=${threeSixtyCode.code}`} allowFullScreen={true} allow="xr-spatial-tracking"></iframe></div>
                      :
                        <div className={cx(className, s.bgbanner)}><iframe className={cx(s.borderTopImageRadius)} style={{ width: '100%', height: '480px', border: 'none' }} allowFullScreen={true} allow="xr-spatial-tracking; gyroscope; accelerometer" src={`https://kuula.co/share/${threeSixtyCode.code}?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1`} /></div>
                      )
                    }
                    </Col>
                    <Col xs={12} md={12} lg={12} className={cx(s.hiddenxs, s.noPadding)}>
                        <Row>
                            {img1 && <Col xs={6} md={6} lg={6} className={cx(s.paddingRight, s.space3)}>
                                <div className={cx(s.imageTwo, 'rightTopBannerRTL')}>
                                    <div onClick={() => openImageLightBox(1)} className={cx(className, s.bgbanner)} style={{ backgroundImage: `url(${img1})` }}>
                                    </div>
                                </div>
                            </Col>}
                            {img4 && <Col xs={6} md={6} lg={6} className={cx(s.paddingLeft, s.space3)}>
                                <div className={cx(s.imageTwo, 'rightTopBannerRTL')}>
                                    <div onClick={() => openImageLightBox(3)} className={cx(className, s.bgbanner)} style={{ backgroundImage: `url(${img4})` }}>
                                    </div>
                                </div>
                            </Col>}
                            {img2 && <Col xs={6} md={6} lg={6} className={cx(s.paddingRight, s.space3)}>
                                <div className={cx(s.imageTwo, 'rightTopBannerRTL')}>
                                    <div onClick={() => openImageLightBox(2)} className={cx(className, s.bgbanner, s.borderRadiusBottomImage)} style={{ backgroundImage: `url(${img2})` }}>
                                    </div>
                                </div>
                            </Col>}
                            {img5 && <Col xs={6} md={6} lg={6} className={cx(s.paddingLeft, s.space3)}>
                                <div className={cx(s.imageTwo, 'rightTopBannerRTL')}>
                                    <div onClick={() => openImageLightBox(4)} className={cx(className, s.bgbanner, s.borderRadiusBottomImage)} style={{ backgroundImage: `url(${img5})` }}>
                                    </div>
                                </div>
                            </Col>}
                        </Row>
                    </Col>
                </div>
            );
        } else {
            return (
                <img src={path + source} className={className} alt={'ListingCoverPhoto'} />
            );
        }
    }
}

export default withStyles(s)(ListGridCoverPhoto);


// WEBPACK FOOTER //
// src/components/ListGridCoverPhoto/ListGridCoverPhoto.js